import { asyncLoad } from '@util'
const AsynInfo = asyncLoad(() =>
  import('@components/LocalMerchant/VR/Detail/Info')
)

export default {
  path: 'info',
  component: AsynInfo,
  sat: '全景管理/info'
}
